export const Search = (props) => (
  <svg
    className='Search'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='inherit'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...props?.style }}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.66659 7.3335C2.66659 4.75617 4.75592 2.66683 7.33325 2.66683C9.91058 2.66683 11.9999 4.75617 11.9999 7.3335C11.9999 8.59085 11.5027 9.73206 10.6941 10.5712C10.6713 10.5887 10.6494 10.6079 10.6285 10.6288C10.6077 10.6496 10.5885 10.6715 10.571 10.6943C9.73181 11.5029 8.5906 12.0002 7.33325 12.0002C4.75592 12.0002 2.66659 9.91083 2.66659 7.3335ZM11.0784 12.0214C10.0519 12.8425 8.74993 13.3335 7.33325 13.3335C4.01954 13.3335 1.33325 10.6472 1.33325 7.3335C1.33325 4.01979 4.01954 1.3335 7.33325 1.3335C10.647 1.3335 13.3333 4.01979 13.3333 7.3335C13.3333 8.75017 12.8423 10.0522 12.0212 11.0786L14.4713 13.5288C14.7317 13.7891 14.7317 14.2112 14.4713 14.4716C14.211 14.7319 13.7889 14.7319 13.5285 14.4716L11.0784 12.0214Z'
      fill='inherit'
    />
  </svg>
);

export const SearchIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.886 17.2541 14.5978 16.0412 15.8566C16.0071 15.8828 15.9742 15.9116 15.9429 15.9429C15.9116 15.9742 15.8828 16.0071 15.8566 16.0412C14.5978 17.2541 12.886 18 11 18C7.13401 18 4 14.866 4 11ZM16.6177 18.0319C15.078 19.2635 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.125 19.2635 15.078 18.0319 16.6177L21.7071 20.2929C22.0977 20.6834 22.0977 21.3166 21.7071 21.7071C21.3166 22.0977 20.6834 22.0977 20.2929 21.7071L16.6177 18.0319Z'
      fill='inherit'
    />
  </svg>
);
